import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, signal, ViewEncapsulation } from '@angular/core';
import { injectDialogRef } from '@workbuddy/ui/v2/blocks/dialog';
import { ButtonComponent, ButtonDisplayStyle, ButtonSize } from '@workbuddy/ui/v2/components/button';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { CheckboxComponent } from '@workbuddy/ui/v2/fields/checkbox';
import { TaskCompletionBlockersComponent } from './task.completion.blockers.component';
import { TaskCompletionDialogContent } from './task.completion.dialog.content';
import { isAuthorisingTaskCompletionDialog } from './task.completion.dialog.kind';
import { taskCompletionDialogBridgeStyles, taskCompletionDialogStyleId } from './task.completion.dialog.theme';

/** Closes with true only when an authorised user ticked the opt-in and chose Complete; every other way out changes nothing. */
@Component({
  selector: 'task-completion-dialog',
  templateUrl: 'task.completion.dialog.component.html',
  styleUrls: ['task.completion.dialog.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TaskCompletionBlockersComponent, CheckboxComponent, ButtonComponent],
})
export class TaskCompletionDialogComponent {

  public readonly $content = input.required<TaskCompletionDialogContent>({ alias: 'content' });

  // A fresh dialog per refusal, so the opt-in starts unticked every time it opens.
  protected readonly $authorised = signal(false);
  protected readonly $overridable = computed(() => isAuthorisingTaskCompletionDialog(this.$content().kind));
  protected readonly primary = ButtonDisplayStyle.Primary;
  protected readonly buttonSize = ButtonSize.Medium;

  private readonly dialogRef = injectDialogRef<boolean>();
  private readonly document = inject(DOCUMENT);

  public constructor() {

    DesignSystem.Mount(this.document, taskCompletionDialogStyleId, taskCompletionDialogBridgeStyles);
  }

  protected dismiss(): void {

    this.dialogRef.dismiss();
  }

  protected complete(): void {

    if (!this.$overridable() || !this.$authorised()) return;
    this.dialogRef.close(true);
  }
}
